/**
 * @file legacy-grn-notice.tsx
 * @module app/modules/inward/components/legacy-grn-notice
 * @description Notice on the Goods Received Notes list during the move to Inward: this GRN process
 *   stays fully available (Create GRN from the PO, existing GRN access); GRNs can also be created in
 *   the new UProcure Inward flow.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.4.0
 * @version 1.4.0
 */

import { Link } from "react-router-dom";

const LegacyGrnNotice = ({ inwardPath }: { inwardPath: string }) => (
  <div
    className="alert alert-info d-flex flex-wrap align-items-center justify-content-between gap-3 fs-15"
    data-testid="legacy-grn-notice"
  >
    <span>
      <strong>Both GRN processes are available.</strong> This page and Create
      GRN on the purchase order work as before. GRNs can also be created in the
      new Inward flow.
    </span>
    <Link
      to={inwardPath}
      className="btn btn-info btn-sm"
      data-testid="legacy-grn-to-inward"
    >
      Go to Inward GRNs
    </Link>
  </div>
);

export default LegacyGrnNotice;
